import React, { ReactNode } from 'react';

import { Redirect, Route, RouteProps } from 'react-router-dom';

import { useAppSelector } from 'hooks/useStore';
import { selectLoggedIn } from 'store/modules/auth';

type RouterState = { from?: string | Location } | undefined;

interface AuthWrappersProps extends RouteProps {
  children: ReactNode;
  redirectTo?: string;
}

export const PrivateRoute = ({
  children,
  redirectTo = '/signin',
  ...otherProps
}: AuthWrappersProps) => {
  const isLoggedIn = useAppSelector(selectLoggedIn);

  if (isLoggedIn) {
    return <Route {...otherProps}>{children}</Route>;
  }

  const { location } = otherProps;

  return (
    <Redirect
      to={{
        pathname: redirectTo,
        state: {
          from: location
            ? `${location.pathname}${location.search}${location.hash}`
            : undefined,
        },
      }}
    />
  );
};

export const PublicRoute = ({
  children,
  redirectTo = '/app/analytics',
  ...otherProps
}: AuthWrappersProps) => {
  const isLoggedIn = useAppSelector(selectLoggedIn);

  if (!isLoggedIn) {
    return <Route {...otherProps}>{children}</Route>;
  }

  const state = otherProps.location?.state as RouterState;

  const redirectTarget = state?.from || redirectTo;

  return <Redirect to={redirectTarget} />;
};
